import { Grid, Card, CardHeader, CardContent, Typography } from '@mui/material';
import { stateApiKeyStore } from '../../../api/states-api-key-store';
import { FormInput } from '../../../components/hook-form/form-input.component';
import { FormSelectDynamic } from '../../../components/hook-form/form-select.dynamic.component';
import { FormFormattedInput } from '../../../components/hook-form/form-formatted-input.component';
import { PHONENUMBER_FORMAT, ZIPCODE_FORMAT } from '../../../constants';
import { FormAutoCompleteSelectDynamic } from '../../../components/hook-form/form-autocomplete-select.dynamic.component';
import { useFormContext } from 'react-hook-form';
import { customersApiKeyStore } from '../../../api/customers-api-key-store';
import { Customer } from '../../../models/customer';

export interface Option {
  value: any;
  label: string;
  isDefault: boolean;
}
interface ContactAddressForm {
  customer?: Customer;
}

export const ContactAddressForm = ({ customer }: ContactAddressForm) => {
  const { setValue, getValues } = useFormContext();
  return (
    <Card elevation={0}>
      <CardHeader
        className="subHead"
        title={
          <Typography variant="h3" color="textPrimary">
            ADDRESS
          </Typography>
        }
      />
      <CardContent className="formContainer">
        <Grid container spacing={2}>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={6} sm={6} xl={6} xs={6}>
                <FormInput name="street" label="Street Address" />
              </Grid>
              <Grid item lg={3} sm={3} xl={3} xs={3}>
                <FormInput name="city" label="City" />
              </Grid>
              <Grid item lg={3} sm={3} xl={3} xs={3}>
                <FormAutoCompleteSelectDynamic
                  name="state"
                  label="State"
                  getQueryKeyConfig={() => stateApiKeyStore.getStates()}
                  optionsValueKey="stateID"
                  optionsLabelKey="stateName"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={3} sm={3} xl={3} xs={3}>
                <FormFormattedInput label="Zip Code" name="zipcode" format={ZIPCODE_FORMAT} />
              </Grid>
              <Grid item lg={3} sm={3} xl={3} xs={3}>
                <FormFormattedInput name="contactPhone" label="Contact Phone" format={PHONENUMBER_FORMAT} />
              </Grid>
              <Grid item lg={6} sm={6} xl={6} xs={6}>
                <FormInput
                  name="contactEmail"
                  label="Contact Email"
                  validationQueryRoute={(value: string) =>
                    customersApiKeyStore.validateCustomerContact(value, customer?.customerID ?? 0)
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
